import { api } from "@/plugins/api";
const url = "/api/v1"; // inject("url_prefix");
import * as cmUtil from "@/utils/cmUtil";

// 로그인
// export async function login(username, password) {
//   cmUtil.resetStore();
//   const response = await api.post(`${api}auth/login`, {
//     username,
//     password,
//   });
//   // Save tokens to local storage or session storage
//   if (response.data.access_token) {
//     localStorage.setItem("token", response.data.access_token);
//     localStorage.setItem("token_refreshToken", response.data.refresh_token);
//   }
//   return response.data;
// }

// 리프레쉬로부터 엑세스토큰 가져오기
export async function refreshAccessToken() {
  const refreshToken = cmUtil.getLocalStorage("token_refreshToken");
  if (!refreshToken) {
    throw new Error("refresh 토큰정보가 없습니다.");
  }

  const response = await api.post(`${url}/login/refreshToken`, {
    refreshToken: refreshToken,
  });
  if (response.data.access_token) {
    localStorage.setItem("token_refreshToken", response.data.newAccessToken);
  }
  return response.data.access_token;
}

// 엑세스토큰 가져오기
// export async function getAccessToken() {
//   return localStorage.getItem("gv.accessToken");
// }

// 로그아웃 하기
export async function logout() {
  //const res = await api.post(`${url}/common/logout`, {});
  cmUtil.resetStore();
  //return res;
}
